import React, { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import PAGE_ROUTES from '../utils/constant';
import MainConatiner from './MainConatiner';
import { getCurrentAuth } from '../hooks/http-server';
import useCommonDetails from '../hooks/useCommonDetails';
import GlobalSearchContextProvider from '../context/GlobalSearchContext';

interface PrivateRouteProps {
  allowedRoles: any[];
  children: ReactNode;
  allowedTeams?: any[]; // Optional
}

const PrivateRoute: FC<PrivateRouteProps> = ({
  allowedRoles,
  children,
  allowedTeams,
}) => {
  const currentUserInfo = useCommonDetails();
  const auth = getCurrentAuth();

  const role = currentUserInfo ? currentUserInfo.roleId : null;
  const team = currentUserInfo ? currentUserInfo.teamId : null;
  const isGodMode = currentUserInfo ? currentUserInfo.isGodMode : false;

  if (!auth) {
    // Redirect to login if not authenticated
    return <Navigate to={PAGE_ROUTES.LOGIN} />;
  }

  const isRoleAllowed = isGodMode || (role && allowedRoles.includes(role));
  const isTeamAllowed = isGodMode || !allowedTeams || (team && allowedTeams.includes(team));

  if (auth && isRoleAllowed && isTeamAllowed) {
    // Render the children inside the main container if the role and (optional) team are allowed
    return (
      <GlobalSearchContextProvider>
        <MainConatiner>{children as JSX.Element}</MainConatiner>
      </GlobalSearchContextProvider>
    );
  }

  // Redirect to the home page if access is not allowed
  return <Navigate to={PAGE_ROUTES.HOME} />;
};

export default PrivateRoute;
